const validator = require('ui-validator');

const v = validator.validators;

const validations = {
  phone: {
    required: v.required({ message: 'Enter a valid phone number' }),
    validTelephone: v.validTelephone({ message: 'Enter a valid phone number' }),
    suspicious: v.suspicious(),
  },
};

export default validations;

